import * as React from "react";
import { Box, Grid, TextField, Typography } from "@mui/material";

export default function MultipleTextInputs({ question, onAnswer = () => {} }) {
	const numItems = Object.keys(question.answer.value).length;
	const week = question.answer.week;
	const lastWeekIndex = week.length - 1;
	const [selectedAnswer, setSelectedAnswer] = React.useState(
		new Array(numItems).fill("")
	);

	React.useEffect(() => {
		setSelectedAnswer(new Array(numItems).fill(""));
	}, [numItems, question]);

	const handleSetAnswer = (i, value) => {
		const updatedAnswers = [...selectedAnswer];
		updatedAnswers[i] = value.trim();
		setSelectedAnswer(updatedAnswers);

		let formatAnswer = {};
		updatedAnswers.forEach((ans, i) => {
			formatAnswer[i + 1] = ans;
		});

		onAnswer({
			canProceed: updatedAnswers.filter((a) => a).length > 0,
			answer: formatAnswer,
		});
	};

	return (
		<React.Fragment>
			<Box
				className="choices-container"
				sx={{ px: 4, textAlign: "center" }}
			>
				{question.questionHeaderText && (
					<Typography variant="h5" sx={{ mt: 1 }}>
						{question.questionHeaderText}
					</Typography>
				)}
				{Object.keys(question.answer.value).map((key, i) => (
					<Grid container sx={{ mt: 2 }} key={i} alignItems="center">
						<Grid item sm={2} xs={2}>
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									flex: 1,
								}}
							>
								<Box
									sx={{
										flex: 1,
										color:
											i % week.length === lastWeekIndex
												? "red"
												: "inherit",
									}}
								>
									{week[i % week.length]}
								</Box>
								<Box sx={{ flex: 1 }}>{parseInt(key)}</Box>
							</Box>
						</Grid>
						<Grid item sm={10} xs={10}>
							<TextField
								fullWidth
								value={selectedAnswer[i]}
								onChange={(e) =>
									handleSetAnswer(i, e.target.value)
								}
								variant="outlined"
								size="small"
							/>
						</Grid>
					</Grid>
				))}
			</Box>
		</React.Fragment>
	);
}
